import { apiClient, handleApiRequest } from '@/services/api/client'

export interface OutboxPerson {
  email: string
  name: string
  role: string | null
  role_label: string | null
  teacher_code: string | null
  mail_count: number
  login_count: number
  latest_at: string | null
}

export interface OutboxMailItem {
  id: string
  subject: string
  status: string
  at: string | null
  has_html: boolean
  theme: string
}

export interface OutboxTheme {
  id: string
  name: string
  hint: string
  items: OutboxMailItem[]
}

export interface OutboxPersonMails {
  recipient_email: string
  recipient_name: string
  role: string | null
  role_label: string | null
  themes: OutboxTheme[]
}

export interface OutboxMailDetail {
  id: string
  recipient_email: string
  recipient_name: string | null
  subject: string
  status: string
  at: string | null
  body_html: string
  last_error: string | null
  theme: string
  theme_name: string
}

export interface OutboxPeopleParams {
  q?: string
  role?: string
  auffaellig?: boolean
  since?: string
  status?: string
}

export interface OutboxMailsParams {
  status?: string
  theme?: string
  since?: string
}

export const emailOutboxApi = {
  listPeople: (params?: OutboxPeopleParams) =>
    handleApiRequest<{ people: OutboxPerson[] }>(
      apiClient.get('/api/v1/superadmin/email-outbox/people', {
        params: params && Object.keys(params).length ? params : undefined,
      }),
    ),
  listMails: (recipient: string, params?: OutboxMailsParams) =>
    handleApiRequest<OutboxPersonMails>(
      apiClient.get('/api/v1/superadmin/email-outbox/mails', {
        params: { recipient, ...params },
      }),
    ),
  getMail: (id: string) =>
    handleApiRequest<OutboxMailDetail>(
      apiClient.get(`/api/v1/superadmin/email-outbox/mails/${id}`),
    ),
}
